(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  var $swiperSelector = $('.blog_slider');

  $swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;

    var swiper = new Swiper(".blog_slider.swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      slidesPerView: 4,
      slidesPerGroup: 1,
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        767: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        575: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 2
        }
      },
      navigation: {
        nextEl: '.swiper-button-next-old',
        prevEl: '.swiper-button-prev-old',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('' + number).slice(-2);
        },
        formatFractionTotal: function (number) {
          return ('' + number).slice(-2);
        },
        renderFraction: function (currentClass, totalClass) {
          return  '<div class="swiper-button-prev swiper-button-prev-old"></div>'+
            '<span class="' + currentClass + '"></span>' +
            '<span> / </span>' +
            '<span class="' + totalClass + '"></span>' +
            '<div class="swiper-button-next swiper-button-next-old"></div>';
          },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: '90',
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".collection_slider_section .collection_slider", {
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    onlyExternal: true,
    navigation: {
      nextEl: ".swiper-button-next-new",
      prevEl: ".swiper-button-prev-new",
    },
  });

  var $swiperSelector = $('.collection_slider_section .collection_slider_product_wrapper');
  $swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;

    var swiper = new Swiper(".collection_slider_product_wrapper.swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      slidesPerGroup: 1,
      breakpoints: {
        1920: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        320: {
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-the-real-ones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.ftroInit === '1') return;
    root.dataset.ftroInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.ftro-card'));
    var dropdowns = Array.prototype.slice.call(root.querySelectorAll('.ftro-filter'));
    var chipsWrap = root.querySelector('.ftro-chips');
    var modal = root.querySelector('.ftro-modal');
    var modalBody = modal ? modal.querySelector('.ftro-modal__body') : null;
    var modalStage = modal ? modal.querySelector('[data-modal-stage]') : null;
    var muteBtn = modal ? modal.querySelector('[data-mute]') : null;
    var curVideo = null;
    var stagedVideo = null;
    var modalProgressFrame = null;
    var modalSwapTimer = null;
    var modalSwapToken = 0;
    var selected = { skintype: [], concerns: [], ingredient: [], categories: [] };
    var visible = cards.slice();
    var curIndex = 0;
    var modalOpen = false;

    // ---- "show more" pagination (grid) ----
    var moreBtn = root.querySelector('.ftro-more');
    var moreWrap = root.querySelector('.ftro-morewrap');
    var PAGINATE = root.getAttribute('data-paginate') === '1';
    var RESPONSIVE = root.getAttribute('data-responsive') === '1';
    var INIT_ROWS = parseInt(root.getAttribute('data-init-rows'), 10) || 2;
    var LOAD_ROWS = parseInt(root.getAttribute('data-load-rows'), 10) || 2;
    var COLS_D = parseInt(root.getAttribute('data-cols'), 10) || 6;
    var COLS_T = parseInt(root.getAttribute('data-cols-t'), 10) || 4;
    var COLS_M = parseInt(root.getAttribute('data-cols-m'), 10) || 3;
    var isRoutineLanding = !!root.closest('.page-routine-application-landing');
    var mqMobile = window.matchMedia(isRoutineLanding ? '(max-width: 749px)' : '(max-width: 640px)');
    var mqTablet = window.matchMedia(
      isRoutineLanding ? '(min-width: 750px) and (max-width: 1024px)' : '(max-width: 0px)'
    );
    function currentCols() {
      if (mqMobile.matches) return COLS_M;
      if (mqTablet.matches) return COLS_T;
      return COLS_D;
    }
    // Responsive mode: paginate only on mobile (grid); desktop shows all (horizontal scroll).
    function paginating() { return RESPONSIVE ? (mqMobile.matches || mqTablet.matches) : PAGINATE; }
    function initialPageLimit() { return INIT_ROWS * currentCols(); }
    function resetPage() { pageLimit = paginating() ? initialPageLimit() : Infinity; }
    var pageLimit = Infinity;
    resetPage();

    // ---- inline card autoplay (muted), pause when off-screen / modal open ----
    var cardVideos = Array.prototype.slice.call(root.querySelectorAll('.ftro-card__video'));
    function playVid(v) { if (modalOpen) return; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function inView(v) {
      var r = v.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) &&
             r.right > 0 && r.left < (window.innerWidth || document.documentElement.clientWidth);
    }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) playVid(en.target);
          else en.target.pause();
        });
      }, { threshold: 0.35 });
      cardVideos.forEach(function (v) { io.observe(v); });
    } else {
      cardVideos.forEach(playVid);
    }
    function pauseCardVideos() { cardVideos.forEach(function (v) { v.pause(); }); }
    function resumeCardVideos() { cardVideos.forEach(function (v) { if (inView(v)) playVid(v); }); }

    function closeAllPanels() { dropdowns.forEach(function (d) { d.classList.remove('open'); }); }

    dropdowns.forEach(function (dd) {
      var btn = dd.querySelector('.ftro-filter__btn');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dd.classList.contains('open');
        closeAllPanels();
        if (!isOpen) dd.classList.add('open');
      });
      dd.querySelector('.ftro-filter__panel').addEventListener('click', function (e) { e.stopPropagation(); });
      Array.prototype.forEach.call(dd.querySelectorAll('input[type="checkbox"]'), function (cb) {
        cb.addEventListener('change', function () {
          var cat = cb.dataset.cat, val = cb.dataset.value;
          if (cb.checked) { if (selected[cat].indexOf(val) === -1) selected[cat].push(val); }
          else { selected[cat] = selected[cat].filter(function (v) { return v !== val; }); }
          resetPage();
          apply();
        });
      });
    });
    document.addEventListener('click', closeAllPanels);

    function matches(card) {
      for (var cat in selected) {
        var sel = selected[cat];
        if (!sel.length) continue;
        var have = (card.dataset[cat] || '').split(' ').filter(Boolean);
        var ok = sel.some(function (v) { return have.indexOf(v) !== -1; });
        if (!ok) return false;
      }
      return true;
    }

    function updateFilterActive() {
      dropdowns.forEach(function (dd) {
        var cat = dd.getAttribute('data-cat');
        var has = selected[cat] && selected[cat].length > 0;
        dd.classList.toggle('is-active', !!has);
      });
    }

    function apply() {
      visible = [];
      var shownIdx = 0;
      cards.forEach(function (c) {
        if (matches(c)) {
          visible.push(c);
          c.style.display = (shownIdx < pageLimit) ? '' : 'none';
          shownIdx++;
        } else {
          c.style.display = 'none';
        }
      });
      renderChips();
      updateFilterActive();
      var paginationEnabled = paginating();
      var hasMore = paginationEnabled && visible.length > pageLimit;
      if (moreBtn) {
        moreBtn.hidden = !hasMore;
        moreBtn.disabled = !hasMore;
      }
      if (moreWrap) {
        moreWrap.hidden = !hasMore;
      }
    }

    function labelFor(cat, val) {
      var cb = root.querySelector('input[data-cat="' + cat + '"][data-value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
      return cb ? cb.dataset.label : val;
    }

    function renderChips() {
      if (!chipsWrap) return;
      chipsWrap.innerHTML = '';
      Object.keys(selected).forEach(function (cat) {
        selected[cat].forEach(function (val) {
          var chip = document.createElement('span');
          chip.className = 'ftro-chip';
          var txt = document.createTextNode(labelFor(cat, val));
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('aria-label', 'Remove');
          btn.textContent = '×';
          btn.addEventListener('click', function () {
            selected[cat] = selected[cat].filter(function (v) { return v !== val; });
            var cb = root.querySelector('input[data-cat="' + cat + '"][data-value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
            if (cb) cb.checked = false;
            resetPage();
            apply();
          });
          chip.appendChild(txt);
          chip.appendChild(btn);
          chipsWrap.appendChild(chip);
        });
      });
    }

    // ---- scroll lock (background must not scroll while modal is open) ----
    var savedScrollY = 0;
    function lockScroll() {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
    }
    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, savedScrollY);
    }

    // ---- modal ----
    function stopModalProgress() {
      if (modalProgressFrame !== null) {
        window.cancelAnimationFrame(modalProgressFrame);
        modalProgressFrame = null;
      }
    }

    function renderModalProgress(video, progress) {
      if (!video || !progress) return;
      var ratio = isFinite(video.duration) && video.duration > 0
        ? Math.min(1, Math.max(0, video.currentTime / video.duration))
        : 0;
      progress.style.transform = 'scaleX(' + ratio + ')';
    }

    function startModalProgress(video, progress) {
      if (modalProgressFrame !== null) return;
      function tick() {
        renderModalProgress(video, progress);
        if (video.isConnected && !video.paused && !video.ended) {
          modalProgressFrame = window.requestAnimationFrame(tick);
        } else {
          modalProgressFrame = null;
        }
      }
      modalProgressFrame = window.requestAnimationFrame(tick);
    }

    function clearPendingModalSwap() {
      modalSwapToken += 1;
      if (modalSwapTimer !== null) {
        window.clearTimeout(modalSwapTimer);
        modalSwapTimer = null;
      }
      if (stagedVideo) {
        try { stagedVideo.pause(); } catch (e) {}
        stagedVideo = null;
      }
      if (modalStage) modalStage.innerHTML = '';
      return modalSwapToken;
    }

    function mountModalTemplate(target, template) {
      if (!target) return;
      target.innerHTML = '';
      if (template && 'content' in template) target.appendChild(template.content.cloneNode(true));
      else if (template) target.innerHTML = template.innerHTML;
    }

    function activateModalVideo(video) {
      curVideo = video || null;
      if (!video) {
        if (muteBtn) muteBtn.hidden = true;
        return;
      }

      video.muted = true;
      video.preload = 'auto';
      if (muteBtn) { muteBtn.hidden = false; muteBtn.classList.add('muted'); }
      var fillEl = modalBody.querySelector('.ftro-vprogress__fill');
      if (fillEl) {
        fillEl.style.transform = 'scaleX(0)';
        video.addEventListener('play', function () { startModalProgress(video, fillEl); });
        video.addEventListener('pause', function () { renderModalProgress(video, fillEl); });
        video.addEventListener('loadedmetadata', function () { renderModalProgress(video, fillEl); });
        video.addEventListener('seeking', function () { renderModalProgress(video, fillEl); });
        video.addEventListener('ended', function () {
          fillEl.style.transform = 'scaleX(1)';
          stopModalProgress();
        });
        if (!video.paused && !video.ended) startModalProgress(video, fillEl);
      }
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function commitStagedModal(token) {
      if (token !== modalSwapToken || !modalStage || !modalStage.childNodes.length) return;
      if (modalSwapTimer !== null) {
        window.clearTimeout(modalSwapTimer);
        modalSwapTimer = null;
      }
      if (curVideo) {
        try { curVideo.pause(); } catch (e) {}
      }
      stopModalProgress();
      modalBody.innerHTML = '';
      while (modalStage.firstChild) modalBody.appendChild(modalStage.firstChild);
      var nextVideo = stagedVideo;
      stagedVideo = null;
      activateModalVideo(nextVideo);
    }

    function fill() {
      if (!visible.length) return;
      var card = visible[curIndex];
      var tpl = card.querySelector('template.ftro-detail');
      var swapToken = clearPendingModalSwap();

      if (!modalBody.childNodes.length || !modalStage) {
        if (curVideo) {
          try { curVideo.pause(); } catch (e) {}
        }
        stopModalProgress();
        mountModalTemplate(modalBody, tpl);
        activateModalVideo(modalBody.querySelector('video'));
        return;
      }

      mountModalTemplate(modalStage, tpl);
      stagedVideo = modalStage.querySelector('video');
      if (!stagedVideo) {
        commitStagedModal(swapToken);
        return;
      }

      stagedVideo.muted = true;
      stagedVideo.preload = 'auto';
      var frameRequested = false;
      function swapAfterFirstFrame() {
        if (frameRequested || swapToken !== modalSwapToken) return;
        frameRequested = true;
        if (typeof stagedVideo.requestVideoFrameCallback === 'function') {
          stagedVideo.requestVideoFrameCallback(function () { commitStagedModal(swapToken); });
        } else {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () { commitStagedModal(swapToken); });
          });
        }
      }
      stagedVideo.addEventListener('loadeddata', swapAfterFirstFrame, { once: true });
      stagedVideo.addEventListener('canplay', swapAfterFirstFrame, { once: true });
      if (stagedVideo.readyState >= 2) swapAfterFirstFrame();
      var stagedPlay = stagedVideo.play();
      if (stagedPlay && stagedPlay.catch) stagedPlay.catch(function () {});
      modalSwapTimer = window.setTimeout(function () { commitStagedModal(swapToken); }, 1800);
    }

    function openModal(card) {
      if (!modal) return;
      visible = cards.filter(function (c) { return c.style.display !== 'none'; });
      curIndex = visible.indexOf(card);
      if (curIndex < 0) curIndex = 0;
      modalOpen = true;
      pauseCardVideos();
      fill();
      modal.hidden = false;
      lockScroll();
    }

    function closeModal() {
      if (!modal) return;
      clearPendingModalSwap();
      modal.hidden = true;
      stopModalProgress();
      if (curVideo) {
        try { curVideo.pause(); } catch (e) {}
        curVideo = null;
      }
      modalBody.innerHTML = '';
      unlockScroll();
      modalOpen = false;
      resumeCardVideos();
    }

    function step(dir) {
      if (!visible.length) return;
      curIndex = (curIndex + dir + visible.length) % visible.length;
      fill();
    }

    // ---- drag-to-scroll (desktop swipe) ----
    var track = root.querySelector('.ftro-track');
    var dragMoved = false;
    if (track) {
      var isDown = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        isDown = true; dragMoved = false;
        startX = e.pageX; startScroll = track.scrollLeft;
        track.classList.add('ftro-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) dragMoved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('ftro-dragging');
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (dragMoved) { dragMoved = false; return; }
        if (e.target.closest('.ftro-prodtag') || e.target.closest('.ftro-card__prodthumb')) return;
        openModal(card);
      });
    });

    if (modal) {
      Array.prototype.forEach.call(modal.querySelectorAll('[data-close]'), function (el) {
        el.addEventListener('click', closeModal);
      });
      var prev = modal.querySelector('[data-prev]');
      var next = modal.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (muteBtn) muteBtn.addEventListener('click', function () {
        if (!curVideo) return;
        curVideo.muted = !curVideo.muted;
        muteBtn.classList.toggle('muted', curVideo.muted);
      });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') closeModal();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        pageLimit += LOAD_ROWS * currentCols();
        apply();
      });
    }
    if (PAGINATE || RESPONSIVE) {
      var onBreakpoint = function () { resetPage(); apply(); };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onBreakpoint);
      else if (mqMobile.addListener) mqMobile.addListener(onBreakpoint);
      if (mqTablet.addEventListener) mqTablet.addEventListener('change', onBreakpoint);
      else if (mqTablet.addListener) mqTablet.addListener(onBreakpoint);
    }

    apply();
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('.ftro-section');
    Array.prototype.forEach.call(els, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["late-award-flash-sale-products"] && !Shopify.designMode) return;
  try {
    

  const allSections= document.querySelectorAll(".flash-recommended-container")
  allSections.forEach((section,index)=> section.setAttribute("id", "section-"+index))
  
  $(document).ready(function() {
    $('#recommended-products-1').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-0`).offset().top - 140
      }, 1000);
    });
  });
  
  $(document).ready(function() {
    $('#recommended-products-2').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-1`).offset().top - 140
      }, 1000);
    });
  });
  
  $(document).ready(function() {
    $('#recommended-products-3').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-2`).offset().top - 140
      }, 1000);
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promi-page-bf-creators"] && !Shopify.designMode) return;
  try {
    
  $('.creator-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   dots: true,
   arrows: true,
   infinite: false,
   focusOnSelect: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      },
    }
  ]
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-by-wishtrend"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Members-only notice popup (same as on product pages) — the APPLY button uses this for
  // non-logged-in visitors so they get the modal instead of a hard redirect to login.
  if (!window.wtMembersOnly) {
    window.wtMembersOnly = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      var ov = document.createElement('div');
      ov.className = 'wt-alert';
      ov.innerHTML = '<div class="wt-alert__box" role="dialog" aria-modal="true"><p class="wt-alert__msg"></p><button type="button" class="wt-alert__ok">Confirm</button></div>';
      ov.querySelector('.wt-alert__msg').textContent = 'Only members can apply. Please log in or create an account first.';
      ov.querySelector('.wt-alert__ok').addEventListener('click', function () {
        try { localStorage.setItem('routine_return_url', window.location.href); } catch (err) {}
        window.location.href = '/account/login';
      });
      document.body.appendChild(ov);
      ov.querySelector('.wt-alert__ok').focus();
      return false;
    };
  }
  function getPath(obj, path) {
    if (!path) return obj;
    return path.split('.').reduce(function (o, k) { return (o == null) ? undefined : o[k]; }, obj);
  }
  // Several banners can point at the same routine product, so responses are shared
  // per URL — one request per distinct product, not one per banner.
  var pending = {};
  function fetchStats(url) {
    if (!pending[url]) {
      pending[url] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return pending[url];
  }
  function initJoined(el) {
    if (!el || el.dataset.rbwDone === '1') return;
    var url = el.getAttribute('data-rbw-api');
    if (!url) return;
    el.dataset.rbwDone = '1';
    var field = el.getAttribute('data-rbw-field') || '';
    fetchStats(url).then(function (json) {
      if (!json) return;
      var val = getPath(json, field);
      if (val === undefined || val === null) val = (typeof json === 'number') ? json : (json.count != null ? json.count : json.joined);
      if (val !== undefined && val !== null) el.textContent = val;
    });
  }
  // The section usually sits below the fold, so a stack of banners would otherwise fire
  // its whole batch of API calls during page load. Hold each one until its banner is
  // about to be seen; a banner already in view resolves on the observer's first callback.
  var observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initJoined(entry.target);
        });
      }, { rootMargin: '200px' })
    : null;
  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-rbw-joined]');
    Array.prototype.forEach.call(els, function (el) {
      if (observer && el.dataset.rbwDone !== '1') observer.observe(el);
      else initJoined(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-journey"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '[data-routine-journey]';
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const DESKTOP_RADIUS = 120;
  const DESKTOP_SIDE_OVERHANG = 100;
  const MOBILE_RADIUS = 18;
  const MOBILE_SIDE_OVERHANG = 18.5;
  const ROUTE_END_INSET = 0.5;

  const numberFrom = (value, fallback) => {
    const match = String(value ?? '').match(/\d+/);
    const parsed = match ? Number.parseInt(match[0], 10) : Number.NaN;
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const getPath = (object, path) => {
    if (!path) return object;
    return path.split('.').reduce((value, key) => (value == null ? undefined : value[key]), object);
  };

  const dateFromValue = (value) => {
    if (!value) return null;
    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;
    return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  };

  const formatJourneyDate = (date) => {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
      .format(date)
      .replace(',', '.');
  };

  function initDetailPanel(panel) {
    if (!panel) return;
    const dates = panel.querySelectorAll('[data-rj-dates]');
    const endDate = dateFromValue(panel.dataset.endDate);
    let startDate = dateFromValue(panel.dataset.startDate);
    if (!startDate && endDate) {
      startDate = new Date(endDate);
      startDate.setUTCDate(startDate.getUTCDate() - Math.max(0, numberFrom(panel.dataset.durationDays, 7) - 1));
    }
    if (dates.length) {
      const dateText = startDate && endDate
        ? `${formatJourneyDate(startDate)} – ${formatJourneyDate(endDate)} (KST)`
        : (endDate ? `${formatJourneyDate(endDate)} (KST)` : '');
      dates.forEach((date) => {
        date.textContent = dateText;
      });
    }

    const reviewTrack = panel.querySelector('.rj-review-track');
    if (reviewTrack) {
      const reviewIndicator = panel.querySelector('[data-rj-review-indicator]');
      const reviewIndicatorThumb = panel.querySelector('[data-rj-review-indicator-thumb]');
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;

      const updateReviewIndicator = () => {
        if (!reviewIndicator || !reviewIndicatorThumb) return;
        const maxScroll = Math.max(0, reviewTrack.scrollWidth - reviewTrack.clientWidth);
        const indicatorWidth = reviewIndicator.clientWidth;
        const thumbWidth = maxScroll > 0
          ? Math.max(32, indicatorWidth * (reviewTrack.clientWidth / reviewTrack.scrollWidth))
          : indicatorWidth;
        const thumbTravel = Math.max(0, indicatorWidth - thumbWidth);
        const rawProgress = maxScroll > 0 ? reviewTrack.scrollLeft / maxScroll : 0;
        const progress = Math.min(1, Math.max(0, rawProgress));
        reviewIndicatorThumb.style.width = `${thumbWidth}px`;
        reviewIndicatorThumb.style.transform = `translateX(${thumbTravel * progress}px)`;
      };

      const endDrag = (event) => {
        if (pointerId === null || (event.pointerId != null && event.pointerId !== pointerId)) return;
        if (reviewTrack.hasPointerCapture?.(pointerId)) reviewTrack.releasePointerCapture(pointerId);
        pointerId = null;
        reviewTrack.classList.remove('is-dragging');
      };

      reviewTrack.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = reviewTrack.scrollLeft;
        didDrag = false;
        reviewTrack.setPointerCapture?.(pointerId);
      });

      reviewTrack.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) {
          didDrag = true;
          reviewTrack.classList.add('is-dragging');
        }
        if (!didDrag) return;
        event.preventDefault();
        reviewTrack.scrollLeft = startScrollLeft - distance;
      });

      reviewTrack.addEventListener('pointerup', endDrag);
      reviewTrack.addEventListener('pointercancel', endDrag);
      reviewTrack.addEventListener('lostpointercapture', endDrag);
      reviewTrack.addEventListener('dragstart', (event) => event.preventDefault());
      reviewTrack.addEventListener('scroll', updateReviewIndicator, { passive: true });
      reviewTrack.addEventListener('click', (event) => {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }, true);
      window.requestAnimationFrame(updateReviewIndicator);
    }

    const reviewVideos = [...panel.querySelectorAll('.rj-review__video')];
    const playReviewVideo = (video) => {
      video.muted = true;
      const playback = video.play();
      if (playback?.catch) playback.catch(() => {});
    };
    reviewVideos.forEach((video) => {
      const progress = video.closest('.ftro-modal__left')?.querySelector('.ftro-vprogress__fill');
      if (!progress) return;
      let progressFrame = null;
      const renderProgress = () => {
        const ratio = Number.isFinite(video.duration) && video.duration > 0
          ? Math.min(1, Math.max(0, video.currentTime / video.duration))
          : 0;
        progress.style.transform = `scaleX(${ratio})`;
      };
      const startProgress = () => {
        if (progressFrame !== null) return;
        const tick = () => {
          renderProgress();
          if (video.isConnected && !video.paused && !video.ended) {
            progressFrame = window.requestAnimationFrame(tick);
          } else {
            progressFrame = null;
          }
        };
        progressFrame = window.requestAnimationFrame(tick);
      };
      progress.style.transform = 'scaleX(0)';
      video.addEventListener('play', startProgress);
      video.addEventListener('pause', renderProgress);
      video.addEventListener('loadedmetadata', renderProgress);
      video.addEventListener('seeking', renderProgress);
      video.addEventListener('ended', () => {
        progress.style.transform = 'scaleX(1)';
      });
    });
    if (reviewVideos.length && reviewTrack && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) playReviewVideo(entry.target);
          else entry.target.pause();
        });
      }, { root: reviewTrack, threshold: 0.4 });
      reviewVideos.forEach((video) => videoObserver.observe(video));
      panel.rjVideoObserver = videoObserver;
    } else {
      reviewVideos.forEach(playReviewVideo);
    }

    const joined = panel.querySelector('[data-rj-joined]');
    const api = panel.dataset.rjApi;
    if (!joined || !api) return;
    fetch(api, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((json) => {
        if (!json) return;
        let value = getPath(json, panel.dataset.rjField);
        if (value == null) value = typeof json === 'number' ? json : (json.count ?? json.joined);
        if (value != null) joined.textContent = value;
      })
      .catch(() => {});
  }

  function roundedPath(points, radius) {
    if (points.length < 2) return '';
    const distance = (a, b) => Math.hypot(b.x - a.x, b.y - a.y);
    let d = `M ${points[0].x} ${points[0].y}`;

    for (let i = 1; i < points.length - 1; i += 1) {
      const previous = points[i - 1];
      const current = points[i];
      const next = points[i + 1];
      const incomingLength = distance(previous, current) || 1;
      const outgoingLength = distance(current, next) || 1;
      const incomingRadius = Math.min(radius, i === 1 ? incomingLength : incomingLength / 2);
      const outgoingRadius = Math.min(
        radius,
        i === points.length - 2 ? outgoingLength : outgoingLength / 2
      );
      const before = {
        x: current.x + ((previous.x - current.x) / incomingLength) * incomingRadius,
        y: current.y + ((previous.y - current.y) / incomingLength) * incomingRadius,
      };
      const after = {
        x: current.x + ((next.x - current.x) / outgoingLength) * outgoingRadius,
        y: current.y + ((next.y - current.y) / outgoingLength) * outgoingRadius,
      };
      d += ` L ${before.x} ${before.y} Q ${current.x} ${current.y} ${after.x} ${after.y}`;
    }

    const last = points[points.length - 1];
    return `${d} L ${last.x} ${last.y}`;
  }

  function initRoutineJourney(root) {
    if (!root || root.dataset.rjInitialized === 'true') return;

    const board = root.querySelector('[data-rj-board]');
    const rowsElement = root.querySelector('[data-rj-rows]');
    const pool = root.querySelector('[data-rj-pool]');
    const svg = root.querySelector('[data-rj-snake]');
    const showMore = root.querySelector('[data-rj-show-more]');
    if (!board || !rowsElement || !pool || !svg || !showMore) return;
    const footer = showMore.closest('.rj__footer');

    root.dataset.rjInitialized = 'true';

    const cards = [...pool.querySelectorAll('[data-rj-card]')].sort((a, b) => {
      return numberFrom(b.dataset.journey, 0) - numberFrom(a.dataset.journey, 0);
    });
    const initialRows = Math.max(1, numberFrom(root.dataset.initialRows, 2));
    const stepRows = Math.max(1, numberFrom(root.dataset.stepRows, 2));

    let columns = 0;
    let visibleRows = initialRows;
    let rows = [];
    let resizeTimer = null;
    let activeCard = null;

    const getColumns = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const tablet = window.matchMedia('(min-width: 750px) and (max-width: 1024px)').matches;
      const columnValue = mobile
        ? root.dataset.columnsMobile
        : (tablet ? root.dataset.columnsTablet : root.dataset.columnsDesktop);
      const fallback = mobile ? 2 : (tablet ? 4 : 4);
      return Math.max(
        1,
        numberFrom(columnValue, fallback)
      );
    };

    const getVisibleRows = () => rows.slice(0, Math.min(visibleRows, rows.length));

    function bindCard(card) {
      if (card.dataset.rjBound === 'true') return;
      card.dataset.rjBound = 'true';
      const toggle = card.querySelector('[data-rj-toggle]');

      const setCardState = (expanded) => {
        card.classList.toggle('is-expanded', expanded);
        card.setAttribute('aria-expanded', String(expanded));
        if (toggle) toggle.setAttribute('aria-expanded', String(expanded));
      };

      const closeCard = (targetCard, redraw = true) => {
        if (!targetCard) return;
        const group = targetCard.closest('[data-rj-row-group]');
        const host = group?.querySelector('[data-rj-detail-host]');
        targetCard.classList.remove('is-expanded');
        targetCard.setAttribute('aria-expanded', 'false');
        targetCard.querySelector('[data-rj-toggle]')?.setAttribute('aria-expanded', 'false');
        if (host) {
          host.hidden = true;
          host.replaceChildren();
        }
        if (activeCard === targetCard) activeCard = null;
        if (redraw) window.requestAnimationFrame(drawRoute);
      };

      const openCard = (targetCard, redraw = true) => {
        if (activeCard && activeCard !== targetCard) closeCard(activeCard, false);
        const group = targetCard.closest('[data-rj-row-group]');
        const host = group?.querySelector('[data-rj-detail-host]');
        const template = targetCard.querySelector('[data-rj-panel-template]');
        if (!host || !template) return;
        host.replaceChildren(template.content.cloneNode(true));
        host.hidden = false;
        setCardState(true);
        activeCard = targetCard;
        const panel = host.querySelector('[data-rj-detail-panel]');
        initDetailPanel(panel);
        panel?.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', drawRoute, { once: true });
        });
        if (redraw) window.requestAnimationFrame(drawRoute);
      };

      card.rjOpen = openCard;
      card.rjClose = closeCard;

      const toggleCard = () => {
        if (activeCard === card) closeCard(card);
        else openCard(card);
      };

      card.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        event.preventDefault();
        toggleCard();
      });

      card.addEventListener('keydown', (event) => {
        if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        toggleCard();
      });
    }

    function buildRows(preserveVisibleCards = false) {
      const previouslyVisibleCards = preserveVisibleCards
        ? getVisibleRows().reduce((total, row) => total + row.cards.length, 0)
        : 0;

      const cardToReopen = activeCard;
      if (activeCard) {
        activeCard.classList.remove('is-expanded');
        activeCard.setAttribute('aria-expanded', 'false');
        activeCard.querySelector('[data-rj-toggle]')?.setAttribute('aria-expanded', 'false');
        activeCard = null;
      }

      columns = getColumns();
      rowsElement.replaceChildren();
      rows = [];

      for (let index = 0; index < cards.length; index += columns) {
        const rowIndex = rows.length;
        const sourceCards = cards.slice(index, index + columns);
        const visualCards = rowIndex % 2 === 1 ? sourceCards.slice().reverse() : sourceCards;
        const group = document.createElement('div');
        group.className = 'rj__row-group';
        group.dataset.rjRowGroup = '';
        const row = document.createElement('div');
        row.className = 'rj__row';
        const detailHost = document.createElement('div');
        detailHost.className = 'rj__detail-host';
        detailHost.dataset.rjDetailHost = '';
        detailHost.hidden = true;

        visualCards.forEach((card, cardIndex) => {
          card.hidden = false;
          card.style.removeProperty('grid-column-start');
          if (rowIndex % 2 === 1 && cardIndex === 0 && visualCards.length < columns) {
            card.style.gridColumnStart = String(columns - visualCards.length + 1);
          }
          bindCard(card);
          row.appendChild(card);
        });

        group.append(row, detailHost);
        rowsElement.appendChild(group);
        rows.push({ element: row, group, detailHost, cards: visualCards });
      }

      if (preserveVisibleCards) {
        visibleRows = Math.max(initialRows, Math.ceil(previouslyVisibleCards / columns));
      }
      visibleRows = Math.min(visibleRows, rows.length);

      rows.forEach((row, index) => {
        row.group.hidden = index >= visibleRows;
      });
      if (cardToReopen && cardToReopen.rjOpen) cardToReopen.rjOpen(cardToReopen, false);
      updateShowMore();
    }

    function buildRoutePoints() {
      const visible = getVisibleRows();
      if (!visible.length) return [];

      const boardRect = board.getBoundingClientRect();
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const compact = window.matchMedia('(max-width: 1024px)').matches;
      const desktop = window.matchMedia('(min-width: 1025px)').matches;
      const desktopScale = desktop ? Math.min(1, window.innerWidth / 1920) : 1;
      const radius = compact ? MOBILE_RADIUS : DESKTOP_RADIUS * desktopScale;
      const keepRouteInsideBoard = compact;
      const lineWidth = Number.parseFloat(getComputedStyle(root).getPropertyValue('--rj-line-width')) || 2.25;
      const routeLineWidth = mobile ? lineWidth / 2 : lineWidth;
      const lineInset = lineWidth / 2;
      // The board extends beyond the card area to give the route its own gutter.
      // Clamp that gutter to the viewport so the line never leaves the screen.
      const viewportLeft = lineInset - boardRect.left;
      const viewportRight = window.innerWidth - lineInset - boardRect.left;
      const outerLeft = Math.max(viewportLeft, keepRouteInsideBoard ? 0 : -radius);
      const outerRight = Math.min(viewportRight, keepRouteInsideBoard ? boardRect.width : boardRect.width + radius);
      const points = [];

      visible.forEach((row, index) => {
        const rects = row.cards.map((card) => card.getBoundingClientRect());
        const left = Math.min(...rects.map((rect) => rect.left - boardRect.left));
        const right = Math.max(...rects.map((rect) => rect.right - boardRect.left));
        const sideOverhang = compact
          ? MOBILE_SIDE_OVERHANG
          : (desktop ? DESKTOP_SIDE_OVERHANG * desktopScale : null);
        const rowOuterLeft = sideOverhang == null
          ? outerLeft
          : Math.max(viewportLeft, left - sideOverhang);
        const rowOuterRight = sideOverhang == null
          ? outerRight
          : Math.min(viewportRight, right + sideOverhang);
        // Bottom-align the journey line with the card so there is no seam and
        // the thicker active border grows upward from the same baseline.
        const y = rects[0].bottom - boardRect.top - routeLineWidth / 2;
        const leftToRight = index % 2 === 0;
        const isFirst = index === 0;
        const isLastVisible = index === visible.length - 1;
        const entry = leftToRight
          ? (isFirst ? left : rowOuterLeft)
          : (isFirst ? right : rowOuterRight);
        const exit = isLastVisible
          ? (leftToRight ? right - ROUTE_END_INSET : left + ROUTE_END_INSET)
          : (leftToRight ? rowOuterRight : rowOuterLeft);

        if (index === 0) {
          points.push({ x: entry, y });
        } else {
          points.push({ x: leftToRight ? rowOuterLeft : rowOuterRight, y });
        }
        points.push({ x: exit, y });
      });

      return { points, radius };
    }

    function drawRoute() {
      svg.replaceChildren();
      const route = buildRoutePoints();
      if (!route.points || route.points.length < 2) return;

      svg.setAttribute('width', String(board.clientWidth));
      svg.setAttribute('height', String(rowsElement.offsetHeight));

      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('class', 'rj__snake-path');
      path.setAttribute('d', roundedPath(route.points, route.radius));
      svg.appendChild(path);
    }

    function updateShowMore() {
      const isComplete = visibleRows >= rows.length;
      const hasMore = !isComplete;
      const visible = getVisibleRows();
      const lastVisible = !isComplete && visible.length ? visible[visible.length - 1] : null;
      rows.forEach((row) => {
        row.group.classList.toggle('is-last-visible', row === lastVisible);
      });
      showMore.hidden = !hasMore;
      showMore.disabled = !hasMore;
      if (footer) {
        footer.hidden = !hasMore;
      }
    }

    showMore.addEventListener('click', () => {
      if (visibleRows >= rows.length) return;
      visibleRows = Math.min(rows.length, visibleRows + stepRows);

      rows.forEach((row, index) => {
        const shouldShow = index < visibleRows;
        row.group.hidden = !shouldShow;
      });

      updateShowMore();
      drawRoute();
    });

    const handleResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (!root.isConnected) return;
        if (getColumns() !== columns) buildRows(true);
        drawRoute();
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    buildRows(false);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(drawRoute);
    });
  }

  const initAll = (scope = document) => {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initRoutineJourney(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoutineJourney);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-top-3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoutineTop3(root) {
    if (!root || root.dataset.routineTop3Ready === 'true') return;
    root.dataset.routineTop3Ready = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-routine-slide]'));
    var backgrounds = Array.prototype.slice.call(root.querySelectorAll('[data-routine-background]'));
    var stage = root.querySelector('[data-routine-stage]');
    var previousButton = root.querySelector('[data-routine-prev]');
    var nextButton = root.querySelector('[data-routine-next]');
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rolling = root.dataset.autoplay !== 'false' && !prefersReducedMotion;
    var playbackPaused = false;
    var activeIndex = 0;
    var inViewport = true;
    var stillTimer = null;
    var pointerStartX = null;
    var pointerMoved = false;

    if (!slides.length) return;

    function wrap(index) {
      return (index + slides.length) % slides.length;
    }

    function videoAt(index) {
      return slides[index] ? slides[index].querySelector('[data-routine-video]') : null;
    }

    function renderProgress(index) {
      var slide = slides[index];
      var video = videoAt(index);
      var progress = slide ? slide.querySelector('[data-routine-progress]') : null;
      if (!video || !progress) return;
      var ratio = isFinite(video.duration) && video.duration > 0
        ? Math.min(1, Math.max(0, video.currentTime / video.duration))
        : 0;
      var renderedWidth = ratio * (progress.parentElement ? progress.parentElement.clientWidth : 0);
      progress.style.transform = 'scaleX(' + ratio + ')';
      progress.style.opacity = renderedWidth >= 1 ? '1' : '0';
    }

    function startProgress(index) {
      var video = videoAt(index);
      if (!video || video.routineProgressFrame) return;

      function tick() {
        renderProgress(index);
        if (
          index === activeIndex &&
          video.isConnected &&
          !video.paused &&
          !video.ended
        ) {
          video.routineProgressFrame = window.requestAnimationFrame(tick);
        } else {
          video.routineProgressFrame = null;
        }
      }

      video.routineProgressFrame = window.requestAnimationFrame(tick);
    }

    function pauseAll(exceptIndex) {
      slides.forEach(function (slide, index) {
        if (index === exceptIndex) return;
        var video = slide.querySelector('[data-routine-video]');
        if (video) video.pause();
      });
    }

    // Decode a real first frame for videos that have never played. Shopify videos
    // do not always provide a preview image, and an untouched <video> can otherwise
    // render as an empty black rectangle in the two side positions.
    function primeVideoFrame(video) {
      if (!video || video.dataset.routineFrameReady) return;
      video.dataset.routineFrameReady = 'loading';
      video.muted = true;
      video.preload = 'auto';

      function showFirstFrame() {
        var slide = video.closest('[data-routine-slide]');
        if (slide && slide.classList.contains('is-active')) {
          video.dataset.routineFrameReady = '';
          return;
        }
        if (!isFinite(video.duration) || video.duration <= 0) {
          video.dataset.routineFrameReady = '';
          return;
        }
        // Use the frame at 1 second as the inactive-card thumbnail. For an
        // unusually short clip, seek to just before the end instead.
        var targetTime = Math.min(1, Math.max(.04, video.duration - .05));
        var finish = function () {
          var currentSlide = video.closest('[data-routine-slide]');
          if (!currentSlide || !currentSlide.classList.contains('is-active')) video.pause();
          video.dataset.routineFrameReady = 'true';
        };
        video.addEventListener('seeked', finish, { once: true });
        try { video.currentTime = targetTime; } catch (error) {
          video.dataset.routineFrameReady = '';
        }
      }

      if (video.readyState >= 1) {
        showFirstFrame();
      } else {
        video.addEventListener('loadedmetadata', showFirstFrame, { once: true });
        try { video.load(); } catch (error) {}
      }
    }

    function primeInactiveFrames() {
      slides.forEach(function (slide, index) {
        if (index === activeIndex) return;
        primeVideoFrame(slide.querySelector('[data-routine-video]'));
      });
    }

    function playActive(force) {
      clearTimeout(stillTimer);
      if (!inViewport || playbackPaused) return;
      var video = videoAt(activeIndex);

      if (video) {
        video.muted = true;
        if (force || rolling) {
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        }
      } else if (rolling && slides.length > 1) {
        stillTimer = window.setTimeout(function () { setActive(activeIndex + 1); }, 5000);
      }
    }

    function setActive(index) {
      clearTimeout(stillTimer);
      activeIndex = wrap(index);
      var previousIndex = wrap(activeIndex - 1);
      var nextIndex = wrap(activeIndex + 1);

      playbackPaused = false;
      pauseAll(activeIndex);

      slides.forEach(function (slide, slideIndex) {
        slide.classList.remove('is-active', 'is-prev', 'is-next');
        if (slideIndex === activeIndex) slide.classList.add('is-active');
        else if (slideIndex === previousIndex) slide.classList.add('is-prev');
        else if (slideIndex === nextIndex) slide.classList.add('is-next');
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
      });

      backgrounds.forEach(function (item, backgroundIndex) {
        item.classList.toggle('is-active', backgroundIndex === activeIndex);
      });

      var activeVideo = videoAt(activeIndex);
      var activeProgress = slides[activeIndex].querySelector('[data-routine-progress]');
      if (activeProgress) {
        activeProgress.style.opacity = '0';
        activeProgress.style.transform = 'scaleX(0)';
      }
      if (activeVideo) {
        try { activeVideo.currentTime = 0; } catch (error) {}
      }

      root.classList.remove('is-paused');
      primeInactiveFrames();
      playActive(true);
    }

    function togglePlayback() {
      var video = videoAt(activeIndex);

      if (!playbackPaused) {
        playbackPaused = true;
        rolling = false;
        clearTimeout(stillTimer);
        if (video) video.pause();
      } else {
        playbackPaused = false;
        rolling = root.dataset.autoplay !== 'false' && !prefersReducedMotion;
        if (video && video.ended) {
          try { video.currentTime = 0; } catch (error) {}
        }
        playActive(true);
      }

      root.classList.toggle('is-paused', playbackPaused);
    }

    slides.forEach(function (slide, index) {
      var video = slide.querySelector('[data-routine-video]');
      var progress = slide.querySelector('[data-routine-progress]');

      if (video) {
        video.addEventListener('play', function () { startProgress(index); });
        video.addEventListener('pause', function () { renderProgress(index); });
        video.addEventListener('loadedmetadata', function () { renderProgress(index); });
        video.addEventListener('seeking', function () { renderProgress(index); });
        video.addEventListener('ended', function () {
          if (index !== activeIndex) return;
          if (progress) {
            progress.style.opacity = '1';
            progress.style.transform = 'scaleX(1)';
          }
          if (rolling && slides.length > 1) setActive(activeIndex + 1);
        });
      }

    });

    if (stage) {
      stage.addEventListener('pointerdown', function (event) {
        if (event.button && event.button !== 0) return;
        if (event.target.closest('[data-routine-prev], [data-routine-next]')) return;
        pointerStartX = event.clientX;
        pointerMoved = false;
        var activeSlide = slides[activeIndex];
        if (activeSlide) activeSlide.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', function (event) {
        if (pointerStartX === null) return;
        if (Math.abs(event.clientX - pointerStartX) > 8) pointerMoved = true;
      });
      function endPointer(event) {
        if (pointerStartX === null) return;
        var delta = event.clientX - pointerStartX;
        var clickedSlide = event.target.closest('[data-routine-slide]');
        var clickedIndex = clickedSlide ? slides.indexOf(clickedSlide) : -1;
        slides.forEach(function (slide) { slide.classList.remove('is-dragging'); });
        pointerStartX = null;
        if (Math.abs(delta) > 40) {
          setActive(activeIndex + (delta < 0 ? 1 : -1));
        } else if (!event.target.closest('a')) {
          if (clickedIndex >= 0 && clickedIndex !== activeIndex) {
            setActive(clickedIndex);
          } else {
            togglePlayback();
          }
        }
        window.setTimeout(function () { pointerMoved = false; }, 0);
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('click', function (event) {
        if (!pointerMoved) return;
        event.preventDefault();
        event.stopPropagation();
      });
      stage.addEventListener('pointercancel', function () {
        pointerStartX = null;
        pointerMoved = false;
        slides.forEach(function (slide) { slide.classList.remove('is-dragging'); });
      });
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () { setActive(activeIndex - 1); });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () { setActive(activeIndex + 1); });
    }

    root.addEventListener('keydown', function (event) {
      if ((event.key === ' ' || event.key === 'Enter') && event.target.closest('a, button')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        togglePlayback();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inViewport = entry.isIntersecting;
          if (inViewport) playActive(false);
          else {
            clearTimeout(stillTimer);
            var video = videoAt(activeIndex);
            if (video) video.pause();
          }
        });
      }, { threshold: .25 });
      observer.observe(root);
    }

    setActive(0);
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-routine-top3]')) initRoutineTop3(target);
    Array.prototype.forEach.call(target.querySelectorAll('[data-routine-top3]'), initRoutineTop3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-banner"] && !Shopify.designMode) return;
  try {
    
  function onScroll() {
    const nav = document.querySelector('[data-sp-nav]');

    if (window.pageYOffset > 600) {
      nav.classList.add('stick');
    } else {
      nav.classList.remove('stick');
    }
  }

  // Add event listeners for scrolling
  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll(); // Check on page load in case the element is already in the viewport

  $(document).on('click', '.spNav__left a[href^="#"]', function (event) {
    event.preventDefault();

    var targetElement = event.currentTarget;
    var indicatorElement = $('.indicator');

    if (window.innerWidth <= 767) {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 194,
        },
        500
      );
    } else {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 232,
        },
        500
      );
    }
  });

  $(document).on('click', '.spNav__right a[href^="#"]', function (event) {
    event.preventDefault();

    if (window.innerWidth <= 767) {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 194,
        },
        500
      );
    } else {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 232,
        },
        500
      );
    }

    window.addEventListener('hashchange', function () {
      var hash = window.location.hash;
      var targetElement = document.querySelector(hash);
      var indicatorElement = document.querySelector('.indicator');

      if (targetElement) {
        var targetPosition = targetElement.getBoundingClientRect();
        indicatorElement.style.left = targetPosition.left + 'px';
        indicatorElement.style.width = targetPosition.width + 'px';
      }
    });
  });

  $(window).on('scroll', function () {
    if (window.innerWidth <= 767) {
      var scrollPos = $(document).scrollTop() + 194;
    } else {
      var scrollPos = $(document).scrollTop() + 232;
    }
    // Add the offset to the scroll position
    var indicatorElement = $('.indicator');

    $('.spNav__left a').each(function () {
      var currLink = $(this);
      var refElement = $(currLink.attr('href'));

      if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
        var targetPosition = currLink[0].getBoundingClientRect();
        indicatorElement.css('left', targetPosition.left + 'px');
        indicatorElement.css('width', targetPosition.width + 'px');
      }
    });
  });

  $(document).ready(function () {
    var firstLink = $('.spNav__left a').first();
    var indicatorElement = $('.indicator');
    var targetPosition = firstLink[0].getBoundingClientRect();

    indicatorElement.css('left', targetPosition.left + 'px');
    indicatorElement.css('width', targetPosition.width + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-offer"] && !Shopify.designMode) return;
  try {
    
  const offerButtons = document.querySelectorAll('[data-offer-code]');
  offerButtons.forEach(function (ofr) {
    ofr.addEventListener('click', function () {
      navigator.clipboard.writeText(ofr.getAttribute('data-offer-code'));
      document.querySelector('.tooltip_copied').classList.add('active');
      setTimeout(function () {
        document.querySelector('.tooltip_copied').classList.remove('active');
      }, 3000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-skin-info"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.skinInfo-swiper', {
    loop: false,
    slidesPerView: 1.9,
    spaceBetween: 30,
    pagination: {
      el: '.skinInfoPagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.9,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 80,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-video"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.spVideo-swiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.skinInfoPagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
